var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ResidentialProperties',_vm._g(_vm._b({attrs:{"type":_vm.type,"used":_vm.usedProperties,"filter":_vm.filterItems,"required-check":false,"model":_vm.model,"sortable":false,"show-deleted-items":true,"create-label":_vm.$t('selectFieldsToEdit'),"parent":{
      sale: {
        type: _vm.saleType,
      },
    },"disabled-fields":{ 'properties.propertyType': !Boolean(_vm.saleType) }},model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}},'ResidentialProperties',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }